import React from "react";
// import { withRouter } from "react-router";
import Logo from "../menu/Logo.js";
import { Row, Divider } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

const Footer = () => {
  return (
    <div className="flexible-width-max">
      <Row
        style={{
          margin: "36px 0 8px 0px",
          width: "100%",
        }}
      >
        <Divider></Divider>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginRight: "22px",
          }}
          // style={{ width: "50%", margin: "0 auto" }}
        >
          <Logo />
        </div>
      </Row>
      <Row style={{ textAlign: "center", marginBottom: "36px" }}>
        <Link to="/allcats">
          <div style={{ margin: "6px 12px 6px 12px", display: "inline-block" }}>
            All Cats
          </div>
        </Link>
        <Link to="/comparecats">
          <div style={{ margin: "6px 12px 6px 12px", display: "inline-block" }}>
            Compare Cats
          </div>
        </Link>
        <Link to="/allenemies">
          <div style={{ margin: "6px 12px 6px 12px", display: "inline-block" }}>
            Enemies
          </div>
        </Link>
        <Link to="/allstages/search-by-stage-name">
          <div style={{ margin: "6px 12px 6px 12px", display: "inline-block" }}>
            Stages
          </div>
        </Link>
        <Link to="/allstages/search-by-stage-enemies">
          <div style={{ margin: "6px 12px 6px 12px", display: "inline-block" }}>
            Monthly Missions
          </div>
        </Link>
        <Link to="/faq">
          <div style={{ margin: "6px 12px 6px 12px", display: "inline-block" }}>
            About
          </div>
        </Link>
        <Link to="/privacypolicy">
          <div style={{ margin: "6px 12px 6px 12px", display: "inline-block" }}>
            Privacy Policy
          </div>
        </Link>
      </Row>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js